export const defaultFormatDate = "MM/DD/YY - HH:mm"
